import { v4 as v4uuid } from 'uuid';
import { Content } from '@prismicio/client';
import { PrismicLink } from '@prismicio/react';

// Components
import { List } from '@preventx/oxygen';

type LinkListProps = {
  slice: Content.SubMenuItemSliceLinkList;
};

export const LinkList = ({ slice }: LinkListProps) => {
  const id = v4uuid();
  const { primary } = slice;

  return (
    <List
      ul="stack-nav"
      options={primary.links.map((field, index) => ({
        content: <PrismicLink field={field} />,
        key: `submenu-item-linklist-${id}-${index + 1}`,
      }))}
    />
  );
};
